import React, { Component } from "react";
import DisplayCards from "./displaycards";
import DisplaySimpleCards from "./displaySimpleCards";
import TabHeader from "../../forms/tabHeader";
import PieDiagram from "./piechart";
import { ALL, SIPS, FMP } from "../../../store/types";
import { Paper } from "@material-ui/core";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import moment from "moment";
import { FormatCurrency } from "../currencyFormatter";
import {
  getDashboardStats,
  getInvestors,
  getFrequentMailBackRequest,
  getInvestorDetails,
  getSipSummary,
  PosterOpen,
  getSipvalues,
  getFMPdata,
  getSipDashboardCount,
  getFmpDashboardCount,
  getAUMdata,
  getAUMSummary,
} from "../../../store/actions";
import { getMailbackList } from "../../../store/actions/mailback";
import {
  getProfileData,
  KARVY_STOCK_BROKING_LIMITED,
  SAMCO_STOCK,
} from "../../../store/actions/profile";
import { connect } from "react-redux";
import {
  AUTHORIZATION_PENDING,
  AUTHORIZATION_APPROVED,
  AUTHORIZATION_EXPIRED,
  INACTIVE_INVESTORS,
  ACTIVE_INVESTORS,
  NEW_INVESTORS,
  EXPIRING_NEXT_MONTH,
  CLOSED_THIS_MONTH,
  SIP_INVESTMENTS,
} from "../../../store/types";
import Image from "../../Image";
import { DashboardPosterDialog, PosterDialog } from "../customModal";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date().toLocaleDateString(),
      reports: [],
      report: { value: "" },
      Tab: "FREQUENT_REPORTS",
      PosterOpen: true,
      current_sips: "",
      current_fmps: "",
    };
  }

  goToRoute = (path) => () => {
    if (path === SIPS) {
      this.props.history.push({
        pathname: "/dashboard/sip-transactions",
        state: {
          active: path,
        },
      });
    } else if (path === FMP) {
      this.props.history.push({
        pathname: "/dashboard/fmp-transactions",
        state: {
          active: path,
        },
      });
    } else {
      this.props.history.push({
        pathname: "/dashboard/transaction-summary",
        state: {
          active: path,
        },
      });
    }
  };

  goToSIPRoute = (path) => () => {
    this.props.history.push({
      pathname: "/dashboard/SipSummaryTypes",
      state: {
        active: path,
      },
    });
  };
  async componentDidMount() {
    const SIPParams = {
      agent: this.props.token,
      tranflag: "D",
    };
    const sipResponse = await this.props.getSipDashboardCount(SIPParams);
    if (!sipResponse) {
      return;
    }
    const { current_sips } = sipResponse.DtData[0];
    this.setState({
      current_sips: !!current_sips ? current_sips : "0",
    });
    const FMPParams = {
      agent: this.props.token,
      tranflag: "D",
    };
    const fmpResponse = await this.props.getFmpDashboardCount(FMPParams);
    const data = !!fmpResponse?.DtData[0] ? fmpResponse?.DtData[0] : [{}];
    const { Total_fmp } = data;
    this.setState({
      current_fmps: Total_fmp || "0",
    });
    const response = await this.props.getMailbackList();
    if (response) {
      this.setState({
        reports: response.DtData,
      });
    }
    const body = {
      agent: this.props.token,
    };
    this.props.getAUMdata(body);

    this.props.getDashboardStats();
  }

  handleChangeSubReports = (value) => () => {
    this.props.history.push({
      pathname: `/mailBackRequest`,
      state: {
        value: value,
      },
    });
  };

  currencyConverter = (value) => {
    if (Math.abs(Number(value)) >= 1.0e5) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e5)} Lacs`;
    } else if (Math.abs(Number(value)) >= 1.0e7) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e7)} Cr`;
    } else if (Math.abs(Number(value)) >= 1.0e3) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e3)} K`;
    } else {
      return Math.abs(Number(value));
    }
  };

  handleChangeTab = (label) => () => {
    if (label === "AUM_SUMMARY") {
      const body = {
        agent: this.props.token,
      };
      this.props.getAUMSummary(body);
    }
    if (label === "SIP_SUMMARY") {
      const sipParams = {
        Uid: this.props.userId,
        AgentCode: this.props.token,
        DateVal: moment(new Date()).format("MM-DD-YYYY"),
      };
      const api =
        this.props.token === "ARN-0018"
          ? ""
          : this.props.getSipSummary(sipParams);
    }
    this.setState({
      Tab: label,
    });
  };

  gotoNfo = () => {
    this.props.history.push(`/dashboard/nfo-funds`);
  };
  closePoster = async () => {
    this.setState({
      PosterOpen: false,
    });
    await this.props.PosterOpen(1);
  };

  //transaction-summary // kebab case // route names , css class names
  //transactionSummary // camel case // variables, function names.
  //transaction_summary  // snake case //
  //TransactionSummary // PascalCase //Class names

  render() {
    const {
      transactionSummary,
      my_aum,
      numberofschemes,
      profileData,
      dashboardAUMData,
      sipSummaryData,
    } = this.props;
    const AmcAumList = !!dashboardAUMData ? dashboardAUMData.Table2 : [];

    const SipAumList =
      !!sipSummaryData && !!sipSummaryData.DtData ? sipSummaryData.DtData : [];
    const sortPieFundChart =
      !!dashboardAUMData && !!dashboardAUMData.Table2
        ? dashboardAUMData.Table2.sort(
            (a, b) => parseFloat(b.aum_percent) - parseFloat(a.aum_percent)
          )
        : [];

    const fundPieData =
      !!sortPieFundChart && !!sortPieFundChart.length
        ? sortPieFundChart
            .filter((ele) => !!parseFloat(ele.aum))
            .map((ele) => ({
              name: ele.descr,
              value: ele.aum_percent,
              ruppess: ele.aum,
            }))
        : [];

    const AUMDetails =
      !!dashboardAUMData && dashboardAUMData.Table3
        ? dashboardAUMData.Table3
        : [];

    const AUMPieData =
      !!dashboardAUMData && dashboardAUMData.DtData
        ? dashboardAUMData.DtData.filter((ele) => !!parseFloat(ele.aum)).map(
            (ele) => ({
              name: ele.category,
              value: ele.aum_percent,
              ruppess: ele.aum,
            })
          )
        : [];

    return (
      <div className="dashboard-main-container">
        {this.props.posterStatus === 0 && (
          <PosterDialog
              open={this.state.PosterOpen}
              fromDashboard={true}
              close={() => 
                  this.closePoster()
                  }
            />
        )}

        

        <div
          style={{
            position: "fixed",
            right: -20,
            zIndex: 100,
            top: 200,
          }}
        >
          <div
            style={{
              background: "#0076cb",
              // borderRadius: "50%",
              paddingLeft: 20,
              width: 210,
              display: "flex",
              justifyContent: "flex-start",

              fontFamily: "OpenSans-Bold",
              letterSpacing: 0.3,
              boxShadow: "0px 0px 3px 0px black",
              fontSize: 16,
              alignItems: "center",
              height: 40,
              color: "white",
              cursor: "pointer",
            }}
            onClick={this.gotoNfo}
          >
            <Image
              src={"/images/newtransaction_active.png"}
              style={{ height: 18, marginRight: 7 }}
            />
            Create NFO Link
          </div>
        </div>
        <Paper className="dashboard-title-responsive">
          <div className="dashboard-title-company">
            {/* {profileData.Distributor_Name === KARVY_STOCK_BROKING_LIMITED
              ? SAMCO_STOCK
              : profileData.Distributor_Name}{" "} */}
            {profileData.Distributor_Name} Portfolio
          </div>
          {!!this.props.tran_enable_flag &&
            this.props.tran_enable_flag === "N" && (
              <div
                style={{
                  position: "absolute",
                  right: 190,
                  zIndex: 10,
                  top: 10,
                }}
                className="reponsive-title-image"
              >
                <Image
                  src={"/images/my_earnings_button.svg"}
                  style={{ height: 48, cursor: "pointer" }}
                  alt="earnings"
                  onClick={() => this.props.history.push(`/my-earnings`)}
                />
              </div>
            )}
          <div
            style={{ position: "absolute", right: -1, top: -35 }}
            className="dashboard-title-image"
          >
            <Image
              src={"/images/my_earnings_bg.svg"}
              style={{ height: 100 }}
              alt="earnings background"
            />
          </div>
        </Paper>
        <div
          className="dashboard-my-aum"
          style={{ fontFamily: "OpenSans-Bold" }}
        >
          MY AUM
          <span className="dashboard-my-aum-span-1">
            As on :{" "}
            <span className="dashboard-my-aum-span-2">
              {moment(new Date(), "DD/MM/YYYY").format("DD-MM-YYYY")}
            </span>
          </span>
        </div>
        <div className="flex">
          <DisplayCards
            image={"/images/aum_dashboard.svg"}
            name="AUM (INR)"
            values={
              !!AUMDetails && !!AUMDetails[0] && !!AUMDetails[0].AUM
                ? Math.round(parseFloat(AUMDetails[0].AUM)).toLocaleString(
                    "en-IN",
                    {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 0,
                    }
                  )
                : ""
            }
          />
          <DisplayCards
            image={"/images/schemes_dashboard.svg"}
            name="Schemes"
            values={
              !!AUMDetails && !!AUMDetails[0] && !!AUMDetails[0].Scheme_Count
                ? AUMDetails[0].Scheme_Count
                : ""
            }
          />
          <DisplayCards
            image={"/images/investors_dashboard.svg"}
            onClick={() => this.props.history.push("/investors")}
            name="Investors"
            values={
              !!AUMDetails && !!AUMDetails[0] && !!AUMDetails[0].Investor_Count
                ? AUMDetails[0].Investor_Count
                : ""
            }
          />
        </div>
        <div className="piecharts-dashboard">
          {!!AUMPieData.length && (
            <div>
              <div className="dashboard-my-aum" style={{ marginBottom: 0 }}>
                Asset class wise Breakup
              </div>
              <Paper className="pie-chart-paper aum">
                <PieDiagram
                  name="AUM"
                  dataDiffer="AUM"
                  aumpieData={true}
                  symbol="%"
                  className="jing"
                  data={AUMPieData}
                  innerRadius={30}
                  outerRadius={75}
                  height={225}
                  width={200}
                  cy={110}
                  cx={85}
                />
              </Paper>
            </div>
          )}
          {/* <div className="right-pie">
            <Paper className="pie-chart-paper aum">
              <div className="title_dashboard">
                Asset Class Wise Investment Break Up
              </div>
              {!!AUMPieData.length ? (
                <PieDiagram
                  name="AUM"
                  dataDiffer="AUM"
                  aumpieData={true}
                  symbol="%"
                  className="jing"
                  data={AUMPieData}
                  innerRadius={50}
                  outerRadius={75}
                  height={200}
                  width={180}
                  cy={100}
                  cx={85}
                />
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#da251d",
                    fontFamily: "SourceSansPro-SemiBold",
                    fontSize: 18,
                  }}
                >
                  No Data Found
                </div>
              )}
            </Paper>
          </div> */}

          {!!fundPieData.length && (
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                className="dashboard-my-aum"
                style={{ paddingLeft: 20, marginBottom: 0 }}
              >
                AMC wise Breakup
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  boxShadow: "0px 0px 3px 0px lightgray",
                  padding: "10px 15px",
                  // margin: "5px 2px",
                  marginTop: 8,
                }}
              >
                <div
                  className="flexgrow"
                  style={{
                    fontSize: 12,
                    fontFamily: "OpenSans-Regular",
                    textAlign: "center",
                  }}
                >
                  AMC
                </div>
                <div
                  style={{
                    fontSize: 13,
                    fontFamily: "OpenSans-SemiBold",
                    width: 100,
                    textAlign: "center",
                  }}
                >
                  Percentage
                </div>
                <div
                  className="flexgrow"
                  style={{
                    fontSize: 13,
                    fontFamily: "OpenSans-SemiBold",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  INR
                </div>
              </div>
              <Paper
                className="pie-chart-paper fund"
                style={{ maxHeight: 173, overflow: "auto" }}
              >
                {fundPieData.map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      boxShadow: "0px 0px 3px 0px lightgray",
                      padding: "10px 15px",
                      // margin: "5px 10px",
                    }}
                    key={index}
                  >
                    <div
                      className="flexgrow"
                      style={{
                        fontSize: 12,
                        fontFamily: "OpenSans-Regular",
                        textAlign: "center",
                      }}
                    >
                      {!!item.name ? item.name.split("MUTUAL FUND")[0] : ""} MF
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        fontFamily: "OpenSans-SemiBold",
                        width: 100,
                        textAlign: "center",
                      }}
                    >
                      {item.value.toFixed(2)}%
                    </div>
                    <div
                      className="flexgrow"
                      style={{
                        fontSize: 13,
                        fontFamily: "OpenSans-SemiBold",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <FormatCurrency value={item.ruppess} />
                    </div>
                  </div>
                ))}

                {/* <PieDiagram
                name="Fund"
                data={!!fundPieData ? fundPieData : []}
                innerRadius={30}
                aumpieData={true}
                height={225}
                width={225}
                symbol="%"
                cy={100}
                cx={120}
                outerRadius={75}
              /> */}
              </Paper>
            </div>
          )}
        </div>
        <div style={{ margin: "0px 10px 10px" }}>
          "The unit balance reflects (if any) hereby under ETF scheme , is the
          initial allocation only and should not be referred for any purposes ,
          Investors/Distributors are advised to refer the actual unit holding /
          unit balance available in the holding statement provided by Depository
          Participant"
        </div>
        <div
          className="dashboard-my-aum"
          style={{ fontFamily: "OpenSans-Bold" }}
        >
          TRANSACTION SUMMARY
          <span className="dashboard-my-aum-span-1">
            As on :{" "}
            <span className="dashboard-my-aum-span-2">
              {moment(new Date(), "DD/MM/YYYY").format("DD-MM-YYYY")}
            </span>
          </span>
        </div>

        <div className="sales-container">
          <div className="simple-card-container">
            <div className="simple-card-div">
              <DisplaySimpleCards
                image={"/images/transaction_expired_dashboard.svg"}
                name="Authorization Expired"
                count={transactionSummary.expired}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_EXPIRED)}
              />

              <DisplaySimpleCards
                image={"/images/transaction_approved_dashboard.svg"}
                name="Authorization Approved"
                count={transactionSummary.approved}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_APPROVED)}
              />
              <DisplaySimpleCards
                image={"/images/authorization_Pending_dashboard.svg"}
                name="Authorization Pending"
                count={transactionSummary.pending}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_PENDING)}
              />
            </div>
            <div className="simple-card-div">
              <DisplaySimpleCards
                image={"/images/transaction_sips_dashboard.svg"}
                name="SIP Dashboard"
                tooltip={true}
                tooltiptext={"Total count of active SIP'S as of today"}
                count={this.state.current_sips}
                className="simple-card"
                onClick={this.goToRoute(SIPS)}
              />
              <DisplaySimpleCards
                image={"/images/transaction_fmps_dashbaord.svg"}
                name="FMP Dashboard"
                tooltip={true}
                tooltiptext={
                  "Total number of FMP's getting matured in next 30 days"
                }
                count={this.state.current_fmps}
                className="simple-card"
                onClick={this.goToRoute(FMP)}
              />
              <DisplaySimpleCards
                image={"/images/transaction_physical_dashbaord.svg"}
                name="Phygital Transactions"
                count={transactionSummary.PhysicalTransactions}
                className="simple-card"
              />
            </div>
          </div>
        </div>

        <div
          className="tab-container"
          style={{
            justifyContent: "center",
            margin: "25px 20px 15px 20px",
          }}
        >
          <TabHeader
            value="FREQUENT  REPORTS"
            active={this.state.Tab === "FREQUENT_REPORTS"}
            onClick={this.handleChangeTab("FREQUENT_REPORTS")}
          />
          {this.props.token !== "ARN-0018" && (
            <TabHeader
              value="SIP SUMMARY"
              active={this.state.Tab === "SIP_SUMMARY"}
              onClick={this.handleChangeTab("SIP_SUMMARY")}
            />
          )}

          <TabHeader
            value="AUM SUMMARY"
            active={this.state.Tab === "AUM_SUMMARY"}
            onClick={this.handleChangeTab("AUM_SUMMARY")}
          />
        </div>
        {this.state.Tab === "FREQUENT_REPORTS" && (
          <div
            style={{ margin: "20px 0px 50px" }}
            className="transaction-details"
          >
            <Paper style={{ width: "100%" }} className="mailback-reports-div">
              {!!this.state.reports &&
                this.state.reports.map((item) => (
                  <SubReports
                    subtitle={
                      !!item && !!item.KDM_Repdesc
                        ? !!item.KDM_Repdesc.split("-")[2]
                          ? `${item.KDM_Repdesc.split("-")[1]}-${
                              item.KDM_Repdesc.split("-")[2]
                            }`
                          : item.KDM_Repdesc.split("-")[1]
                        : ""
                    }
                    key={item.KDM_Repcode}
                    value={item.KDM_Repcode}
                    onClick={this.handleChangeSubReports(item)}
                  />
                ))}
            </Paper>
          </div>
        )}

        {this.state.Tab === "SIP_SUMMARY" && (
          <div>
            <div className="simple-card-container">
              <div className="simple-card-div">
                <DisplaySimpleCards
                  image={"/images/sip_elm.svg"}
                  name="Expiring Next Month"
                  count={
                    !!sipSummaryData &&
                    !!sipSummaryData.Table2 &&
                    sipSummaryData.Table2[0]
                      ? sipSummaryData.Table2[0].SIP_expired_next_month
                      : 0
                  }
                  className="simple-card"
                  onClick={this.goToSIPRoute(EXPIRING_NEXT_MONTH)}
                />

                <DisplaySimpleCards
                  image={"/images/sip_closed.svg"}
                  name="Closed This Month"
                  count={
                    !!sipSummaryData &&
                    !!sipSummaryData.Table2 &&
                    sipSummaryData.Table2[0]
                      ? sipSummaryData.Table2[0].SIP_Closed_this_month
                      : 0
                  }
                  className="simple-card"
                  onClick={this.goToSIPRoute(CLOSED_THIS_MONTH)}
                />
                <DisplaySimpleCards
                  image={"/images/sip_im.svg"}
                  name="Investments"
                  count={
                    !!sipSummaryData &&
                    !!sipSummaryData.Table2 &&
                    sipSummaryData.Table2[0]
                      ? sipSummaryData.Table2[0].Sip_Investments
                      : 0
                  }
                  className="simple-card"
                  onClick={this.goToSIPRoute(SIP_INVESTMENTS)}
                />
              </div>
            </div>
            {SipAumList.map((item, index) => (
              <AmcAum
                value={item}
                sipSummary={true}
                key={index}
                history={this.props.history}
              />
            ))}
          </div>
        )}

        {this.state.Tab === "AUM_SUMMARY" && (
          <div>
            {!!AmcAumList && AmcAumList.length > 0 ? (
              AmcAumList.map((item, index) => (
                <AmcAum
                  value={item}
                  key={index}
                  history={this.props.history}
                  sipSummary={false}
                />
              ))
            ) : (
              <div
                style={{
                  fontFamily: "OpenSans-SemiBold",
                  color: "#0076cb",
                  fontSize: 15,
                  textAlign: "center",
                }}
              >
                No Data Found
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  ({ authReducer, dashboard, investor, profileReducer }) => {
    const { token, userId, tran_enable_flag, posterStatus, beta_user } =
      authReducer;
    const { count } = investor;
    const { profileData } = profileReducer;
    const {
      transactionSummary = {},
      my_aum,
      numberofschemes,
      aumData,
      fundData,
      totalAum,
      sipSummaryData,
      dashboardAUMData,
    } = dashboard;
    return {
      beta_user,
      token,
      posterStatus,
      dashboardAUMData,
      userId,
      transactionSummary,
      sipSummaryData,
      my_aum,
      count,
      profileData,
      totalAum,
      numberofschemes,
      aumData,
      fundData,
      tran_enable_flag,
    };
  },
  {
    getDashboardStats,
    PosterOpen,
    getSipSummary,
    getInvestors,
    getInvestorDetails,
    getFrequentMailBackRequest,
    getProfileData,
    getMailbackList,
    getSipvalues,
    getFMPdata,
    getSipDashboardCount,
    getFmpDashboardCount,
    getAUMdata,
    getAUMSummary,
  }
)(Dashboard);

export class SubReports extends Component {
  render() {
    return (
      <div
        className="mailback-reports-sub-reports"
        onClick={this.props.onClick}
        value={this.props.value}
      >
        {this.props.subtitle}
        <div>
          <Image src={"/images/arrow_right_grey.svg"} alt="next" height={12} />
        </div>
      </div>
    );
  }
}

export class MyAmcAum extends Component {
  goToRoute = (path, value) => () => {
    this.props.history.push({
      pathname: "/dashboard/investorType",
      state: {
        active: path,
        value: value,
        Type: !!this.props.sipSummary ? "SIP_SUMMARY" : "AUM_SUMMARY",
      },
    });
  };

  render() {
    const { value, dashboardAUMData, sipSummaryData, sipSummary } = this.props;

    const totalArray =
      !sipSummary &&
      !!dashboardAUMData &&
      dashboardAUMData.Table2 &&
      this.props.aumData.DtData
        ? dashboardAUMData.Table2.reduce((prev, curr) => {
            const findItem =
              !!dashboardAUMData &&
              this.props.aumData.DtData.find(
                (ele) => ele.Fund.trim() === curr.fund_code.trim()
              );
            const data = !!findItem ? { ...curr, ...findItem } : { ...curr };
            prev = [...prev, data];
            return prev;
          }, [])
        : [];

    let item = !!sipSummary
      ? !!sipSummaryData &&
        sipSummaryData.Table3.length > 0 &&
        sipSummaryData.Table3.find(
          (ele) => ele.Fund.trim() === value.fund.trim()
        )
      : totalArray.find(
          (ele) => !!ele.Fund && String(ele.Fund).trim() === value.fund_code
        );

    return (
      <div style={{ margin: "20px 0px 10px" }} className="transaction-details">
        <div
          style={{
            backgroundColor: "#f6f6f6",
            width: "100%",
            padding: "10px 20px",
          }}
        >
          <div className="amc-responsive">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Image
                src={
                  !!item && item.image_path
                    ? `https://mfs.kfintech.com/mfs/mobileimages/${
                        !!item.image_path && item.image_path.split("/")[2]
                      }`
                    : null
                }
                style={{ marginRight: 20, height: 30, width: 30 }}
              />
              <div
                style={{
                  fontSize: 15,
                  color: "#0076cb",
                  fontFamily: "OpenSans-Bold",
                }}
              >
                {value.descr}
              </div>
            </div>
            <div className="total-assests-responsive">
              <div>
                {`Total Assets ₹ ${
                  !!value && value.aum ? Math.round(value.aum) : "0"
                }`}
              </div>
              <div
                style={{
                  color: "#7b8495",
                  fontSize: 10,
                  fontFamily: "OpenSans-Regular",
                }}
              >
                {" "}
                (as on date {moment(new Date()).format("DD MMM `YY")})
              </div>
            </div>
          </div>
        </div>
        <div className="sub-title">Investors</div>
        <div className="simple-card-div">
          <DisplaySimpleCards
            image={"/images/new_investors.svg"}
            name="New Investors"
            count={!!item && !!item.New_Investors ? item.New_Investors : "0"}
            className="simple-card"
            onClick={this.goToRoute(NEW_INVESTORS, item)}
          />

          <DisplaySimpleCards
            image={"/images/active_investors.svg"}
            name="Active Investors"
            count={
              !!item && !!item.Active_Investors ? item.Active_Investors : "0"
            }
            className="simple-card"
            onClick={this.goToRoute(ACTIVE_INVESTORS, item)}
          />
          <DisplaySimpleCards
            image={"/images/inactive_investors.svg"}
            name="Inactive Investors"
            count={
              !!item && !!item.Inactive_Investors
                ? item.Inactive_Investors
                : "0"
            }
            className="simple-card"
            onClick={this.goToRoute(INACTIVE_INVESTORS, item)}
          />
        </div>
        <div className="sub-title">Brokerage Details</div>
        <div
          className="Brokerage-boxes"
          // style={{
          //   display: "flex",
          //   flexWrap: "wrap",

          // }}
        >
          <SubAUMClass
            title={!!item && !!item.Previous6thMon ? item.Previous6thMon : "0"}
            date={
              !!item && !!item.Previous6thMonDt ? item.Previous6thMonDt : ""
            }
          />
          <SubAUMClass
            title={!!item && !!item.Previous5thMon ? item.Previous5thMon : "0"}
            date={
              !!item && !!item.Previous5thMonDt ? item.Previous5thMonDt : ""
            }
          />
          <SubAUMClass
            title={!!item && !!item.Previous4thMon ? item.Previous4thMon : "0"}
            date={
              !!item && !!item.Previous4thMonDt ? item.Previous4thMonDt : ""
            }
          />
          <SubAUMClass
            title={
              !!item && !!item.BeforelastMonth ? item.BeforelastMonth : "0"
            }
            date={
              !!item && !!item.BeforelastMonthDt ? item.BeforelastMonthDt : ""
            }
          />
          <SubAUMClass
            title={!!item && !!item.BeforeMonth ? item.BeforeMonth : "0"}
            date={!!item && !!item.BeforeMonthDt ? item.BeforeMonthDt : ""}
          />

          <SubAUMClass
            title={!!item && !!item.PresentMon ? item.PresentMon : "0"}
            date={!!item && !!item.PresentDt ? item.PresentDt : ""}
          />
        </div>
        <div
          style={{
            height: 1,
            width: "100%",
            background: "lightgray",
            marginTop: 20,
          }}
        ></div>
      </div>
    );
  }
}

export const AmcAum = connect(({ dashboard }) => {
  const { dashboardAUMData, sipSummaryData, aumData } = dashboard;

  return { dashboardAUMData, sipSummaryData, aumData };
})(MyAmcAum);

export class SubAUMClass extends Component {
  currencyConverter = (value) => {
    if (Math.abs(Number(value)) >= 1.0e5) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e5)} Lacs`;
    } else if (Math.abs(Number(value)) >= 1.0e7) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e7)} Cr`;
    } else if (Math.abs(Number(value)) >= 1.0e3) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e3)} K`;
    } else {
      return Math.abs(Number(value));
    }
  };

  render() {
    const { title, date } = this.props;
    return (
      <Paper
        style={{
          padding: "15px 25px",
          margin: "5px 15px",
          textAlign: "center",
        }}
      >
        <div style={{ fontFamily: "OpenSans-Bold", color: "#0076cb" }}>
          {!!title ? <FormatCurrency value={title} /> : ""}
        </div>
        <div
          style={{
            fontFamily: "OpenSans-Regular",
            fontSize: 13,
            color: "#6d7278",
          }}
        >
          {date}
        </div>
      </Paper>
    );
  }
}
